import { tick } from 'svelte'

// place files you want to import through the `$lib` alias in this folder.
export async function menuCloseObserver(element: HTMLElement, timeout?: number) {
      const controller = new AbortController()
      const { promise, resolve } = Promise.withResolvers()

      //catch first bubble that goes out from the open click, so it does not close the menu again
      let bubble = false

      function close(ev: Event) {
            if (!bubble) {
                  bubble = true
                  return
            }
            ev.stopPropagation()

            const target = ev.target as HTMLElement | null
            if (target && element.contains(target) ) return

            controller.abort()
            resolve(true)
      }

      document.addEventListener('click', close, { signal: controller.signal })

      if (timeout) setTimeout(resolve, timeout)
      return { promise, resolve }
}

export async function flip(element: HTMLElement, change: Function) {
      element.getAnimations().forEach((ani) => ani.pause())

      const first = element.getBoundingClientRect()

      await change()

      await tick()

      element.getAnimations().forEach((ani) => ani.cancel())

      const last = element.getBoundingClientRect()

      return element.animate(
            [
                  {
                        height: first.height + 'px',
                  },
                  {
                        height: last.height + 'px',
                  },
            ],
            { duration: 300, easing: 'ease-in-out', fill: 'backwards' }
      )
}
